import React, { useContext, useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Aos from "aos";
import axios from "axios";
import Header from "../../components/Header/Header";
import Footer2 from "../../components/Footer/Footer2";
import Div from "../../components/utils/Div";
import { domainProvider } from "../../contexts/DomainContext";
import RegisterForm from "./RegisterForm";
import RegisterImage from "./RegisterImage";

const Register = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { customdomain, titleName } = useContext(domainProvider);
  const [ganarel, setGanarel] = useState([]);

  useEffect(() => {
    Aos.init();
    Aos.refresh();

    axios.get(`${process.env.REACT_APP_APIURL}/admin/getgeneraldetails`).then((res) => {
      setGanarel(res.data.data[0]);
    });

    const user = JSON.parse(localStorage.getItem("user"));
    if (user?.token || user?.refreshToken) {
      navigate("/vendor/main-flow");
    }
  }, [navigate]);

  return (
    <>
      <Helmet>
        <title>
          {t("create_store_title")} - {titleName}
        </title>
        {ganarel?.favicon && <link rel="icon" href={ganarel.favicon} />}
      </Helmet>
      <Header />
      <Div id="privacyPolicy">
        <div className="mt-5 grid grid-cols-1 md:grid-cols-3 place-content-center mx-auto">
          <div className="registration-form w-full mx-auto md:border-r-4 border-gray-200 md:pr-5">
            <RegisterForm />
          </div>
          <RegisterImage />
        </div>
      </Div>
      <Footer2 />
    </>
  );
};

export default Register;
